import { render, staticRenderFns } from "./teacher-list.vue?vue&type=template&id=1d162c96&"
import script from "./teacher-list.vue?vue&type=script&lang=js&"
export * from "./teacher-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "teacher-list.vue"
export default component.exports